import caseLawyer from './case-forms/case-lawyer.reducer';
import caseForm from './case-forms/case-forms.reducer';
import caseReview from './case-review/case-review.reducer';
import group from './group/group.reducer';
import userGroup from './user-group/user-group.reducer';
import subscriptionPlan from './case-forms/subscription-plan.reducer';

/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  userGroup,
  group,
  caseReview,
  caseForm,
  caseLawyer,
  subscriptionPlan,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
